import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import PageStructure from 'flarum/forum/components/PageStructure';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Link from 'flarum/common/components/Link';
const AREAS = {
  gear: 'Gear, tech and building',
  playing: 'Playing, theory and practice'
};
export default class HallOfFamePage extends Page {
  members = null;
  oninit(vnode) {
    super.oninit(vnode);
    app.setTitle('Hall of Fame');
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/hall-of-fame'
    }).then(r => {
      this.members = r.data;
      m.redraw();
    });
  }
  view() {
    return m(PageStructure, {
      className: "HallOfFamePage",
      sidebar: () => m(IndexSidebar, null)
    }, m("h1", null, "Hall of Fame"), m("p", null, "The members whose advice built GuitarTalk. Their posts still help guitarists every day, and Ask GuitarTalk names them when it uses their advice."), !this.members ? m(LoadingIndicator, null) : Object.keys(AREAS).map(area => m("section", null, m("h2", null, AREAS[area]), m("div", {
      className: "HofGrid"
    }, this.members.filter(mem => mem.area === area).map(mem => this.card(mem))))));
  }
  card(mem) {
    return m("div", {
      className: "HofCard"
    }, m(Link, {
      className: "HofCard-head",
      href: app.route('user', {
        username: mem.username
      })
    }, mem.avatarUrl ? m("img", {
      className: "HofCard-avatar",
      src: mem.avatarUrl,
      alt: "",
      loading: "lazy"
    }) : m("span", {
      className: "HofCard-avatar HofCard-initial"
    }, mem.username[0]), m("span", null, m("span", {
      className: "HofCard-name"
    }, mem.username), mem.title && m("span", {
      className: "GtTitle"
    }, mem.title))), m("div", {
      className: "HofCard-stats"
    }, mem.posts.toLocaleString(), " posts", mem.memberSince ? ` · member since ${mem.memberSince}` : '', mem.quoted > 0 ? ` · quoted in ${mem.quoted} Ask answer${mem.quoted === 1 ? '' : 's'}` : ''), mem.signature && m("div", {
      className: "GtSignature GtSignature--open"
    }, m.trust(mem.signature)), mem.threads.length > 0 && m("div", {
      className: "HofCard-label"
    }, "Questions they helped with"), mem.threads.length > 0 && m("ul", {
      className: "HofCard-threads"
    }, mem.threads.map(t => m("li", null, m(Link, {
      href: t.url
    }, t.title), " ", m("span", {
      className: "HofCard-year"
    }, t.year)))));
  }
}
flarum.reg.add('noriods-ask', 'forum/components/HallOfFamePage', HallOfFamePage);